import { calculateTargetMonthFromDate } from "src/choosePlan/components/plans/Plans";
import { getSurveyAnswers } from "src/hooks/survey/answers";
import saveToBraze, { addDataToCRMQueue } from "src/utils/brazeUploader";
import { calculateBMI } from "src/utils/calculateGoals";
import { NON_MED_PLAN } from "src/utils/medEligibility";
import { getPersonalizedTargetDate } from "src/utils/pace";
import { getIndexFromGraphId } from "src/utils/pace/graphIndex";
import {
  ITERABLE_RECOMMENDED_PLAN_PROPERTIES,
  savePlanToBraze,
} from "src/utils/plans";
import getStore from "src/utils/redux/store";
import { isHealthRoute } from "@utils/userSegment";
import {
  hasWeightLossGoal,
  isEligibleForStandaloneHRTBuyflow,
} from "@utils/userSegment/features";

export const saveRecommendedPlanToCRM = async (actionParams?: {
  params?: { useQueue?: boolean };
}) => {
  const useQueue = Boolean(actionParams?.params?.useQueue);
  const state = getStore().getState();
  const surveyAnswers = getSurveyAnswers(state);
  const { currentBMI, targetBMI } = calculateBMI(surveyAnswers);
  const { recommendedPlan, recommendationContext } = state;

  // Clear purchase recommendations for FREEMIUM health route users
  // They don't have a recommended plan, so we clear any stale data from previous flows
  if (
    isHealthRoute() &&
    recommendationContext.recommendedHealthPlan === NON_MED_PLAN.FREEMIUM
  ) {
    const clearedProperties: Record<string, any> = {};
    Object.values(ITERABLE_RECOMMENDED_PLAN_PROPERTIES).forEach((key) => {
      clearedProperties[key] = null;
    });
    clearedProperties[
      ITERABLE_RECOMMENDED_PLAN_PROPERTIES.recommendedPlanType
    ] = NON_MED_PLAN.FREEMIUM;
    if (useQueue) {
      addDataToCRMQueue({ user: clearedProperties });
    } else {
      await saveToBraze({ user: clearedProperties });
    }
    return;
  }

  // Only persist a plan when a valid one is resolved
  if (!recommendedPlan?.noom_plan_id) {
    return;
  }

  // Skip sending targetBMI and targetMonthNameFull for health route users without weight loss goal
  const shouldSkipWeightLossData = isHealthRoute() && !hasWeightLossGoal();

  let targetMonthNameFull: string | undefined;
  if (!shouldSkipWeightLossData) {
    const graphId = isEligibleForStandaloneHRTBuyflow()
      ? "hrtOptIn"
      : "medOptIn";
    const targetDate = getPersonalizedTargetDate(getIndexFromGraphId(graphId));
    targetMonthNameFull =
      calculateTargetMonthFromDate(targetDate).targetMonthNameFull;
  }

  await savePlanToBraze(
    {
      currentBMI,
      targetBMI: shouldSkipWeightLossData ? undefined : targetBMI,
      targetMonthNameFull,
      recommendedPlan,
    },
    shouldSkipWeightLossData,
    useQueue
  );
};
